import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Conversion, Payment, Profit } from '../../../models/admModel/finance.model';
import * as config from '../backend.config';

// ----------------------------------------------
// Service for Administrator
// Component: finpaymentsComponent, finconversionsComponent, dashboardComponent
// ----------------------------------------------

const ADDRS_API = config.API;
const FILTER_KEY1 = 'filter-adm-conv-status';
const FILTER_KEY2 = 'filter-adm-conv-publisher';
const FILTER_KEY3 = 'filter-adm-conv-start';
const FILTER_KEY4 = 'filter-adm-conv-end';
const FILTER_KEY5 = 'filter-adm-conv-button';
const FILTER_KEY6 = 'filter-adm-conv-page';

// API description for all commnication with BACK-END for systemlog events management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------
//  Method    URLS                                          Actions                   View
//  GET       api/adm/payments                              get all payments
//  GET       api/adm/profits                               get all profits
//  GET       api/adm/conversions                           get all conversions
//  GET       api/adm/conversions?status=${status}          get all conversions


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })

  export class FinanceService {
    constructor(private http: HttpClient) { }

    // data for table from finpaymentsComponent
    getAllPayment(): Observable<Payment[]> {
        return this.http.get<Payment[]>(ADDRS_API + '/payments');
      }

    // data for chart from dashboardComponent
    getProfit(): Observable<Profit[]> {
        return this.http.get<Profit[]>(ADDRS_API + '/profits');
      }

    // admin-finances-conversions
    getAllConversion(filter: any): Observable<any> {
        return this.http.post(ADDRS_API + '/admin/finance/conversions', filter);
      }

    // TODO: dodać filtrowanie po Publisher, startDate, endDate
    getConversionBy(status: any): Observable<Conversion[]> {
        return this.http.get<Conversion[]>(ADDRS_API + `/conversions?status=${status}`);
      }

    // admin-finance-payments
    // pobieranie konfiguracji
    getConfig(): Observable<any> {
      return this.http.get(ADDRS_API + `/admin/finance/payment-global-settings`);
    }

    setConfig(data: any): Observable<any> {
      return this.http.put(ADDRS_API + `/admin/finance/payment-global-settings`, data);
    }

    getFinanceSymmary(): Observable<any> {
      return this.http.get(ADDRS_API + `/admin/finance/payment-statistics`);
    }

    getPaymentsToday(page: any): Observable<any> {
      return this.http.post(ADDRS_API + '/admin/finance/pending-payments', page);
    }

    getPaymentsAll(page: any): Observable<any> {
      return this.http.post(ADDRS_API + '/admin/finance/historical-payments', page);
    }

    getInvoice(id: any): Observable<any> {
      return this.http.get(ADDRS_API + `/admin/finance/payments/${id}/invoice`);
    }

    payInvoice(id: any): Observable<any> {
      return this.http.post(ADDRS_API + `/admin/finance/payments/${id}/pay`, id);
    }

    revertInvoice(id: any): Observable<any> {
      return this.http.post(ADDRS_API + `/admin/finance/payments/${id}/revert`, id);
    }

    // ----------------------------------------------
    // OBSŁUGA FILTRÓW
    // ADMIN-FINANCE-CONVERSIONS

    public saveFilter(id: number, filter: any): void {
      switch(id){
        case 1: // filter status
          window.sessionStorage.removeItem(FILTER_KEY1);
          window.sessionStorage.setItem(FILTER_KEY1, JSON.stringify(filter));
          break;

        case 2:  // filtr publisher
          window.sessionStorage.removeItem(FILTER_KEY2);
          window.sessionStorage.setItem(FILTER_KEY2, JSON.stringify(filter));
          break;

        case 3: // filtr start date
          window.sessionStorage.removeItem(FILTER_KEY3);
          window.sessionStorage.setItem(FILTER_KEY3, JSON.stringify(filter));
          break;

        case 4: // filtr end date
          window.sessionStorage.removeItem(FILTER_KEY4);
          window.sessionStorage.setItem(FILTER_KEY4, JSON.stringify(filter));
          break;

        case 5: // button
          window.sessionStorage.removeItem(FILTER_KEY5);
          window.sessionStorage.setItem(FILTER_KEY5, JSON.stringify(filter));
          break;

        case 6: // page
          window.sessionStorage.removeItem(FILTER_KEY6);
          window.sessionStorage.setItem(FILTER_KEY6, JSON.stringify(filter));
          break;

      }
    }

    public getFilter(id: number): any {
      switch(id) {
        case 1: // filter status
          const filter1 = window.sessionStorage.getItem(FILTER_KEY1);
          if(filter1)
          {
            return JSON.parse(filter1);
          }
          return null;

        case 2: // filtr publisher
          const filter2 = window.sessionStorage.getItem(FILTER_KEY2);
          if(filter2)
          {
            return JSON.parse(filter2);
          }
          return null;

        case 3: // filtr start
          const filter3 = window.sessionStorage.getItem(FILTER_KEY3);
          if(filter3)
          {
            return JSON.parse(filter3);
          }
          return null;

        case 4: // filtr end
          const filter4 = window.sessionStorage.getItem(FILTER_KEY4);
          if(filter4)
          {
            return JSON.parse(filter4);
          }
          return null;

        case 5: // button on/off
          const filter5 = window.sessionStorage.getItem(FILTER_KEY5);
          if(filter5)
          {
            return JSON.parse(filter5);
          }
          return null;

        case 6: // page
          const filter6 = window.sessionStorage.getItem(FILTER_KEY6);
          if(filter6)
          {
            return JSON.parse(filter6);
          }
          return null;
      }
    }
  }
